import { render, staticRenderFns } from "./FinishTransloadModal.vue?vue&type=template&id=474f9e09&scoped=true"
import script from "./FinishTransloadModal.vue?vue&type=script&lang=js"
export * from "./FinishTransloadModal.vue?vue&type=script&lang=js"
import style0 from "./FinishTransloadModal.vue?vue&type=style&index=0&id=474f9e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474f9e09",
  null
  
)

export default component.exports